import viewportHelper from '@kissui/helpers/src/viewport.helpers'
import {
    VARIATION_PLP,
    VARIATION_SMALL,
    VARIATION_CROSS_SELL,
    VARIATION_PDP
} from '@kissui/components/src/sku/constants'
import { isLoggedIn } from '@kissui/helpers/src/dataLayer'

const getButtonSize = variation => {
    switch (variation) {
        case VARIATION_PLP:
            return viewportHelper.is.mobile ? 'small' : 'large'
        case VARIATION_SMALL:
            return 'small'
        default:
            return 'large'
    }
}

function getComputedProps(activeSku, activeLongSku, sku, longSku, disableTracking) {
    const skuProp = activeSku || sku
    const activeLongSkuProp = activeLongSku || longSku
    const disableTrackingProp = disableTracking && `disableTracking=true`

    return { skuProp, activeLongSkuProp, disableTrackingProp }
}

export const renderAddToCart = props => {
    const {
        activeLongSku,
        activeSku,
        category_name = '',
        contact_cta = {},
        hidePrice,
        longSku = '',
        position,
        rendererName = '',
        show_view_details = false,
        sku,
        url,
        variation = VARIATION_PLP,
        view_details_label = 'View details',
        technologies = [],
        disableTracking = false
    } = props

    const buttonSize = getButtonSize(variation)
    let cta_url = url,
        cta_label = view_details_label,
        contact_cta_text = contact_cta.contact_cta_text || '',
        contact_url_anchor = contact_cta.contact_url_anchor || '',
        is_b2b = checkForB2B(technologies)

    // CONTACT US BUTTON
    const { skuProp, activeLongSkuProp, disableTrackingProp } = getComputedProps(
        activeSku,
        activeLongSku,
        sku,
        longSku,
        disableTracking
    )

    function b2bNotLoggedIn(contact_url_anchor, cta_url, cta_label) {
        //CONTACT US BUTTON[ hidePrice = true]
        const linkAttribute = contact_url_anchor ? `link="${cta_url}"` : ''

        return `<nb-cta ${linkAttribute} variation="primary" data-disabletracking="true">${cta_label}</nb-cta>`
    }

    function b2bLoggedIn({
        skuProp,
        activeLongSkuProp,
        buttonSize,
        category_name,
        position,
        rendererName,
        variation,
        disableTrackingProp
    }) {
        return `
                    <nb-add-to-cart
                        sku="${skuProp}"
                        longSku="${activeLongSkuProp}"
                        buttonSize="${buttonSize}"
                        showPrice
                        range='${category_name}'
                        position='${position}'
                        rendererName='${rendererName}'
                        tracking_no_impression="${variation === VARIATION_PDP}"
                        ${disableTrackingProp}
                    >
                    </nb-add-to-cart>
                `
    }

    function remainingCases(cta_url, cta_label) {
        //VIEW DETAILS BUTTON [ hidePrice = false]
        return `<nb-cta link="${cta_url}" variation="primary">${cta_label}</nb-cta>`
    }

    if (hidePrice || show_view_details) {
        if (
            is_b2b &&
            (variation === VARIATION_PDP || variation === VARIATION_CROSS_SELL) &&
            !isLoggedIn()
        ) {
            cta_url = contact_url_anchor
            cta_label = contact_cta_text

            return b2bNotLoggedIn(contact_url_anchor, cta_url, cta_label)
        } else if (is_b2b && variation === VARIATION_PDP && isLoggedIn()) {
            return b2bLoggedIn({
                skuProp,
                activeLongSkuProp,
                buttonSize,
                category_name,
                position,
                rendererName,
                variation,
                disableTrackingProp
            })
        }

        return remainingCases(cta_url, cta_label)
    }

    // ADD TO CART BUTTON
    return `
            <nb-add-to-cart
                sku="${skuProp}"
                longSku="${activeLongSkuProp}"
                buttonSize="${buttonSize}"
                showPrice
                range='${category_name}'
                position='${position}'
                rendererName='${rendererName}'
                tracking_no_impression="${variation === VARIATION_PDP}"
                ${disableTrackingProp}
            ></nb-add-to-cart>
        `
}

function checkForB2B(technologies) {
    return Array.isArray(technologies) && technologies.some(tech => tech.includes('pro'))
}
